import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { EBreakpoint } from '../../../constants/breakpoints';
import { useMedia } from '../../../hooks/useMedia';
import { useSidebar } from '../../../hooks/useSidebar';
import type { ISideBarItem } from '../../../interfaces/ISidebar';
import { MaterialIcon } from '../../common/MaterialIcon';

interface SidebarItemProps extends ISideBarItem {
  expanded: boolean;
}

export const SidebarItem: React.FC<SidebarItemProps> = ({
  to,
  text,
  icon,
  active,
  expanded,
}) => {
  const { toggleSideBar } = useSidebar();
  const { t } = useTranslation();
  const { down: isMobile } = useMedia(EBreakpoint.MD);

  return (
    <Link
      to={to}
      // When collapsed the label is hidden, so surface it as a native tooltip.
      // A custom popover would be clipped by the nav's vertical overflow.
      title={expanded ? undefined : t(text)}
      onClick={() => {
        // Close the overlay sidebar after navigating on small screens
        if (isMobile) {
          toggleSideBar();
        }
      }}
      className='no-underline'>
      <div
        className={clsx(
          'flex items-center text-gray-500 hover:bg-primary-hover w-[calc(100%-1px)]',
          expanded ? 'gap-3 py-1.5 px-3.5' : 'justify-center py-3',
          active &&
            'bg-primary-hover text-primary-base shadow-[inset_2px_0_0_0_#0554e3]',
        )}>
        <MaterialIcon
          icon={icon}
          classes={['icon', 'text-lg', 'leading-none']}
          type='outlined'
        />
        {expanded && (
          <span className='whitespace-nowrap text-xs font-light'>
            {t(text)}
          </span>
        )}
      </div>
    </Link>
  );
};

export default SidebarItem;
